import React, { useEffect, useState } from 'react';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      // Show after scrolling past first viewport
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`md:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pb-3 pt-2 transition-all duration-300 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0 pointer-events-none'}`} style={{
    background: 'linear-gradient(to top, rgba(241,244,248,0.98) 60%, rgba(241,244,248,0))'
  }} data-id="element-88">
      <a href="#pricing" className="flex items-center justify-between gap-2 w-full bg-[#2D9596] text-white rounded-full px-4 py-3 shadow-2xl active:scale-[0.98] transition-transform" data-id="element-89">
        <div className="flex items-center gap-2 min-w-0" data-id="element-90">
          <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center shrink-0" data-id="element-91">
            <span className="text-base" data-id="element-92">⭐</span>
          </div>
          <div className="text-left min-w-0" data-id="element-93">
            <div className="text-[9px] uppercase tracking-wider text-white/80 font-bold leading-none mb-0.5" data-id="element-94">
              Más elegido · Precio de lanzamiento
            </div>
            <div className="text-sm font-bold leading-tight truncate" data-id="element-95">
              Quiero mi Kit + PRO · $27.990
            </div>
          </div>
        </div>
        <span className="text-lg shrink-0" data-id="element-96">→</span>
      </a>
    </div>;
}